import React from 'react'
import styled, { css, StyledProps } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  margin: 20px 0;
  flex-wrap: wrap;

  ${props => props.theme.media.mobile`
      margin: 8px 16px;
  `}
`

const Breadcrumb = css`
  color: ${(props: StyledProps<{}>) => props.theme.color.secondary200};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  transition: 0.3s color;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    &::after {
      content: '';
      display: block;
      margin: 0 8px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: ${(props: StyledProps<{}>) => props.theme.color.secondary200};
    }
  }
`

const StaticBreadcrumb = styled.span`
  ${Breadcrumb};

  cursor: default;
`

const LinkBreadcrumb = styled.span`
  ${Breadcrumb};

  a {
    text-decoration: none;
    color: inherit;
  }

  &:hover {
    color: ${(props: StyledProps<{}>) => props.theme.color.primary600};
  }
`

type BreadcrumbType = {
  path?: string
  title: string | React.ReactElement
}

type BreadcrumbsProps = {
  breadcrumbs?: BreadcrumbType[] // current url
  items?: BreadcrumbType[] // last pieces of breadcrumbs
  onClick?: (breadcrumb: BreadcrumbType) => void
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items = [], breadcrumbs = [], onClick }) => {
  return (
    <Wrapper>
      {[...breadcrumbs, ...items].map((item, i) => {
        return item.path ? (
          <LinkBreadcrumb key={i} onClick={() => onClick && onClick(item)}>
            {item.title}
          </LinkBreadcrumb>
        ) : (
          <StaticBreadcrumb key={i} onClick={() => onClick && onClick(item)}>
            {item.title}
          </StaticBreadcrumb>
        )
      })}
    </Wrapper>
  )
}
